import { convertSectionGroup } from './section-group';

export const convertLayoutSectionGroup = (
  entry,
  sectionGroupData,
  parsedConfig,
) => {
  const sectionGroup = convertSectionGroup(entry, sectionGroupData);

  sectionGroup.type = parsedConfig.type;
  sectionGroup.name = parsedConfig.name;

  return sectionGroup;
};
